
window.staticUrl = function(url) {
    return app.settings.staticUrl + url;
};
window.urlStaticUrl = function(url) {
    return `url('${app.settings.staticUrl + url}'`;
};
